// src/api/donations.js

import axios from 'axios';

/**
 * Recupera tutti i donation goals dall’API
 */
export function fetchDonationGoals() {
  return axios.get('/api/donation-goals', {
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
  });
}

/**
 * Crea un PaymentIntent per una donazione e registra la donation in Strapi
 * @param {Object} params
 * @param {string} params.userId              — documentId dell'utente in Strapi
 * @param {string} params.stripeCustomerId    — ID del Customer in Stripe
 * @param {number} params.amount              — importo in centesimi
 * @param {string} params.currency            — valuta (es. "eur")
 * @param {string} [params.donationGoalId]    — documentId del donation goal (opzionale)
 * @param {Object} [params.metadata]          — metadata aggiuntivi
 * @param {string} [params.type]              — tipo donazione ("one-time" o "recurring")
 */
export function createDonationIntent({
  userId,
  stripeCustomerId,
  amount,
  currency = 'eur',
  donationGoalId = null,
  metadata = {},
  type = 'one-time',
}) {
  return axios.post(
    '/api/donations/create-intent',
    {
      userId,
      stripeCustomerId,
      amount,
      currency,
      donationGoalId,
      metadata,
      type,
    },
    { headers: { 'Content-Type': 'application/json' }, withCredentials: true }
  );
}

/**
 * Conferma una donazione dopo il pagamento
 * @param {Object} params
 * @param {string} params.localDonationId     — documentId della donation in Strapi
 * @param {string} params.paymentIntentId     — ID del PaymentIntent di Stripe
 */
export function confirmDonation({ localDonationId, paymentIntentId }) {
  return axios.post(
    '/api/donations/confirm',
    { localDonationId, paymentIntentId },
    { headers: { 'Content-Type': 'application/json' }, withCredentials: true }
  );
}

/**
 * Crea una donazione direttamente con status 'succeeded' per pagamenti in contanti
 * @param {Object} params
 * @param {string} params.userId              — documentId dell'utente in Strapi
 * @param {number} params.amount              — importo in centesimi
 * @param {string} params.currency            — valuta (es. "eur")
 * @param {string} [params.donationGoalId]    — documentId del donation goal (opzionale)
 * @param {Object} [params.metadata]          — metadata aggiuntivi
 * @param {string} [params.type]              — tipo donazione ("one-time" o "recurring")
 */
export function createCashDonation({
  userId,
  amount,
  currency = 'eur',
  donationGoalId = null,
  metadata = {},
  type = 'one-time',
}) {
  return axios.post(
    '/api/donations/create-cash',
    { userId, amount, currency, donationGoalId, metadata, type },
    { headers: { 'Content-Type': 'application/json' }, withCredentials: true }
  );
}

export function fetchDonationsForGoals() {
  return axios.get('/api/donations', {
    params: {
      populate: 'donation_goal',
      'pagination[pageSize]': 100,
    },
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
  });
}

export function fetchSucceededDonations(userId) {
  return axios.get('/api/donations', {
    params: {
      'filters[donationStatus][$eq]': 'succeeded',
      'filters[user][id][$eq]': userId,
      populate: 'donation_goal',
      'pagination[pageSize]': 100,
    },
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
  });
}

/**
 * Recupera le statistiche delle donazioni (per admin o dashboard)
 */
export function fetchDonationStats() {
  return axios.get('/api/donations/stats', {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
  });
}

/**
 * Recupera le statistiche personalizzate delle donazioni di un utente specifico
 */
export function fetchUserDonationStats(userId) {
  return axios.get(`/api/donations/stats/user/${userId}`, {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
  });
}

/**
 * Recupera le donazioni di un utente specifico (per admin o verifiche)
 */
export function fetchUserDonations(userId) {
  return axios.get(`/api/donations/user/${userId}`, {
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
  });
}
